import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { applyTypography, BaseButton, useT } from '@repo/common';

import { ReactComponent as SearchIcon } from '@repo/common/assets/icons/20px/icon_20px_search.svg';

import { getSearchQna } from '../../../api/qna/qnaSearch.api';

const TXT_SEARCH_KEY = 'b16';

const QnaSearchInput = ({ defaultValue = '' }) => {
  const t = useT();
  const inputRef = useRef(null);
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState(defaultValue);
  const [isFocusedSearch, setIsFocusedSearch] = useState(false);

  useEffect(() => {
    setSearchTerm(defaultValue);
  }, [defaultValue]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleSearch = async () => {
    if (!searchTerm.trim()) return;

    const result = await getSearchQna({
      keyword: searchTerm,
      page: 0,
    });

    navigate(
      `/community/qna/search?keyword=${encodeURIComponent(searchTerm)}`,
      {
        state: { searchResult: result },
      },
    );
    window.location.reload();
  };

  return (
    <div className='flex justify-center'>
      <div className='w-full'>
        <div
          className={`relative flex items-center rounded-[30px] bg-grayscale-gray00 shadow-3
                  border-[1.6px] transition-colors
                  ${
                    isFocusedSearch || searchTerm
                      ? 'border-grayscale-gray07'
                      : 'border-transparent'
                  }`}
        >
          <input
            ref={inputRef}
            type='text'
            placeholder={t('what is your question?', '무엇이 궁금하신가요?')}
            value={searchTerm}
            onChange={handleSearchChange}
            onFocus={() => setIsFocusedSearch(true)}
            onBlur={() => setIsFocusedSearch(false)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') handleSearch();
            }}
            className={`${applyTypography(
              TXT_SEARCH_KEY,
            )} w-full h-14 py-[10px] pl-6 pr-[12px] soft-60 text-text-primary focus:outline-none rounded-[30px]`}
          />
          <BaseButton
            type='primary'
            icon={<SearchIcon />}
            bgclass='absolute right-2 h-10 w-10 rounded-full'
            onClick={handleSearch}
          />
        </div>
      </div>
    </div>
  );
};

export default QnaSearchInput;
